﻿package com.mgacreative.hotel.feature.ai_assistant.di

import com.mgacreative.hotel.feature.ai_assistant.ui.AiAssistantViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getAiAssistantFeatureModule() = module {
    viewModel { AiAssistantViewModel(get()) }
}
